const InterstitialPopup = () => {
  const body = document.querySelector('body');
  const popup = document.querySelector('.js-modal-interstitial');
  const session = sessionStorage.getItem('hasClosedPopup');

  const openModal = () => {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', false);
    body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', true);
    body.style.overflow = null;

    setSession();
  };

  const setSession = () => {
    sessionStorage.setItem('hasClosedPopup', '1');
  };

  if (popup && ! session) {
    const isOpen = popup.classList.contains('is-visible');
    const closeBtn = popup.querySelector('.js-modal-close');
    const ctaBtn = popup.querySelector('.js-modal-action');

    if (! isOpen) {
      openModal();
    } else {
      closeModal();
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', setSession);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
  }
};

export default InterstitialPopup;
